import React from 'react';
import { Link } from 'react-router-dom';

const RegisterErrorPage: React.FC = () => {
  return (
    <div
      style={{
        minHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center', // Vertically center
        alignItems: 'center',     // Horizontally center
        padding: '2rem',
        color: 'var(--text-normal)',
        backgroundColor: 'var(--background)',
        textAlign: 'center',
      }}
    >
      <div>
        <h1 style={{ color: 'var(--text-header)' }}>Registration Failed</h1>
        <p style={{ marginTop: '1rem' }}>
          The registration link is invalid or has expired.
        </p>
        <p style={{ marginTop: '0.5rem' }}>
          Please contact the game administrator and request a new invitation email.
        </p>
      </div>
    </div>
  );
};

export default RegisterErrorPage;